<template>
  <lancamentos-lista-base tipo="pagar" titulo="Financeiro - Contas a Pagar" />
</template>

<script>
import LancamentosListaBase from '@/pages/financeiro/LancamentosListaBase.vue';

export default {
  name: 'ContasPagarLista',
  components: {
    LancamentosListaBase,
  },
};
</script>
